import { createSlice } from "@reduxjs/toolkit";

import {
  compareInString,
  getName,
  isBetEqualToOutcome
} from "../../../container/SportsBookNode/utils/common/functions";
import { initialState } from "./initialState";

// import { getName } from "../../../container/SportsBook/Utils/common";

const BetSlipSlice = createSlice({
  name: "BetSlip",
  initialState,
  reducers: {
    setSwitchToCombo: (state, action) => {
      state.switchToCombo = action.payload;
    },
    addBet: (state, action) => {
      state.localErrorMsg = false;
      state.serverErrorMsg = "";
      const betFromMatchFound = state.bets?.findIndex((bet) => {
        return compareInString(bet.matchId, action.payload?.matchId);
      });

      if (state.bets?.length && betFromMatchFound !== -1) {
        state.bets = state.bets?.filter((bet) => {
          return !compareInString(bet.matchId, action.payload?.matchId);
        });
      }

      state.bets.push(action.payload);
      state.totalOdds = state.bets
        .reduce((prev, curr) => prev * curr.odds, 1)
        .toFixed(2);
      state.possibleWinAmount = (state.totalOdds * state.stake).toFixed(2);
    },
    removeBet: (state, action) => {
      state.localErrorMsg = false;
      state.serverErrorMsg = "";
      state.bets = state.bets.filter(
        (bet) =>
          !(
            compareInString(bet.matchMarketId, action.payload?.matchMarketId) &&
            isBetEqualToOutcome(bet, action.payload?.outcome)
          )
      );
      state.totalOdds = state.bets
        .reduce((prev, curr) => {
          return prev * curr.odds;
        }, 1)
        .toFixed(2);
      state.possibleWinAmount = (state.totalOdds * state.stake).toFixed(2);

      if (state.bets.length === 0) {
        state.stake = 0.0;
      }
    },
    updateMultiSingleStake: (state, action) => {
      state.localErrorMsg = false;
      state.serverErrorMsg = "";
      state.bets[action.payload.index].stake = action.payload.stake;
    },
    resetBet: (state) => {
      state.localErrorMsg = false;
      state.serverErrorMsg = "";
      state.loading = false;
      state.success = false;
      state.error = false;
      state.bets = [];
      state.bettype = 1;
      state.stake = 0;
      // state.userId = 1;
      state.totalOdds = 0;
      state.possibleWinAmount = 0;
      state.isFastBet = true;
      state.multiPrice = "";
    },
    ClearAllBat: (state) => {
      state.localErrorMsg = false;
      state.serverErrorMsg = "";
      state.loading = false;
      state.success = false;
      state.error = false;
      state.bets = [];
      state.bettype = 1;
      state.stake = 0;
      // state.userId = 1;
      state.totalOdds = 0;
      state.possibleWinAmount = 0;
      state.multiPrice = "";
    },

    placebetStart: (state, action) => {
      if (action.payload?.sponsoredBet) {
        state.sponsoredLoading = true;
        state.sponsoredBetPlaceSuccess = false;
      } else {
        state.loading = true;
      }
    },
    placebetSuccess: (state, action) => {
      state.serverErrorMsg = "";
      if (action.payload?.isSponsored) {
        state.sponsoredLoading = false;
        state.sponsoredBetPlaceSuccess = true;
      } else {
        state.switchToCombo = false;
        state.loading = false;
      }
    },
    placebetFailure: (state, action) => {
      if (action.payload.isSponsored) {
        state.sponsoredLoading = false;
      } else {
        state.loading = false;
        state.error = true;
        state.sponsoredLoading = false;
        state.serverErrorMsg = action?.payload?.error;
      }
    },

    updateStake: (state, action) => {
      state.localErrorMsg = "";
      state.serverErrorMsg = "";
      state.stake = action.payload;
      state.possibleWinAmount = (state.totalOdds * state.stake).toFixed(2);
      state.isTouched = true;
    },

    updateBetType: (state, action) => {
      state.serverErrorMsg = "";
      state.bettype = action.payload;
    },
    updateBetsWithLatestApiData: (state, action) => {
      action?.payload?.bets?.forEach((latestBetData) => {
        const updateIndex = state?.bets.findIndex(
          (bet) =>
            compareInString(latestBetData?.matchId, bet?.matchId) &&
            compareInString(bet?.matchMarketId, latestBetData?.matchMarketId) &&
            isBetEqualToOutcome(bet, latestBetData)
        );

        if (updateIndex !== -1) {
          let updateIndexBet = state?.bets?.[updateIndex];
          state.bets[updateIndex] = {
            ...updateIndexBet,
            odd: latestBetData?.odd,
            odds: latestBetData?.odd,
            outcomeType: {
              ...updateIndexBet?.outcomeType,
              odd: latestBetData?.odd
            },
            ...latestBetData
          };
        }
      });
    },
    updateBetsWithSocketData: (state, action) => {
      state.bets = state.bets.map((bet) => {
        if (bet && !bet?.messageNumber) bet.messageNumber = -1;
        let matchScoreResult = [];
        let matchTime = "";
        let status = "";
        let messageNumber = "";
        let betStatus = "";
        if (compareInString(bet?.matchId, action?.payload?.matchId)) {
          matchScoreResult = bet?.matchScoreResult?.slice(0);
          action?.payload?.matchScoreResult?.forEach((newScore) => {
            const updatedScoreIndex = bet?.matchScoreResult?.findIndex(
              (oldScore) => {
                return (
                  getName(oldScore?.type, "en") ===
                  getName(newScore?.type, "en")
                );
              }
            );

            if (updatedScoreIndex !== -1) {
              matchScoreResult[updatedScoreIndex] = {
                score: newScore?.score,
                type: newScore?.type
              };
            } else {
              matchScoreResult.push({
                score: newScore?.score,
                type: newScore?.type
              });
            }
          });
          matchTime = action?.payload?.matchTime;
          status = action?.payload?.status;
          messageNumber = action?.payload?.messageNumber;
          betStatus = action?.payload?.betStatus
            ? action?.payload?.betStatus
            : bet?.betStatus;
        }
        if (
          bet &&
          action?.payload &&
          action?.payload?.matchMarkets &&
          action?.payload?.matchMarkets?.length &&
          parseInt(bet?.messageNumber) <=
            parseInt(action?.payload?.messageNumber)
        ) {
          let filteredMarketdata = action?.payload?.matchMarkets?.filter(
            ({ matchMarketId }) =>
              compareInString(bet.matchMarketId, matchMarketId) &&
              compareInString(action?.payload?.matchId, bet.matchId)
          );
          if (filteredMarketdata && filteredMarketdata?.length) {
            const filteredBet = filteredMarketdata[0]?.outcomes?.filter(
              (outcome) => isBetEqualToOutcome(bet, outcome)
            );
            const isFilterBetExist = filteredBet && filteredBet?.length;
            const outcomeTypeData = isFilterBetExist
              ? filteredBet?.[0]
              : bet?.outcomeType;
            return {
              ...bet,
              odds: isFilterBetExist ? filteredBet?.[0]?.odd : bet?.odds,
              betStatus: betStatus === "" ? bet?.betStatus : betStatus,
              isSettled: filteredMarketdata?.[0]?.isSettled,
              active: isFilterBetExist ? filteredBet?.[0]?.active : bet?.active,
              outcomeType: {
                ...bet?.outcomeType,
                ...outcomeTypeData
              },
              messageNumber,
              matchTime,
              status,
              matchScoreResult
            };
          }
          return {
            ...bet,
            messageNumber: messageNumber ? messageNumber : bet?.messageNumber,
            matchTime: matchTime ? matchTime : bet?.matchTime,
            status: status ? status : bet?.status,
            matchScoreResult: matchScoreResult?.length
              ? matchScoreResult
              : bet?.matchScoreResult,
            betStatus: betStatus === "" ? bet?.betStatus : betStatus
          };
        } else {
          return {
            ...bet,
            messageNumber: messageNumber ? messageNumber : bet?.messageNumber,
            matchTime: matchTime ? matchTime : bet?.matchTime,
            status: status ? status : bet?.status,
            matchScoreResult: matchScoreResult?.length
              ? matchScoreResult
              : bet?.matchScoreResult,
            betStatus: betStatus === "" ? bet?.betStatus : betStatus
          };
        }
      });

      state.totalOdds = state.bets
        .reduce((prev, curr) => prev * curr.odds, 1)
        .toFixed(2);
      state.possibleWinAmount = (state.totalOdds * state.stake).toFixed(2);
    },
    setIsFirstTime: (state, action) => {
      state.isFirstTime = action.payload;
    },
    setIsFastBet: (state, action) => {
      state.isFastBet = action.payload;
    },
    betLimitStart: (state, action) => {
      state.betlimit = initialState.betlimit;
    },
    betLimitSuccess: (state, action) => {
      state.betlimit = { ...action.payload };
    },
    betLimitFailure: (state) => {
      state.betlimit = initialState.betlimit;
    },
    setServerError: (state, action) => {
      state.serverErrorMsg = action.payload;
    },
    setLocalError: (state, action) => {
      state.localErrorMsg = action.payload;
    }
  }
});

export const {
  setLocalError,
  betLimitStart,
  betLimitSuccess,
  betLimitFailure,
  addBet,
  removeBet,
  updateStake,
  placebetSuccess,
  placebetStart,
  placebetFailure,
  resetBet,
  ClearAllBat,
  updateBetsWithSocketData,
  setIsFirstTime,
  updateMultiSingleStake,
  setIsFastBet,
  setError,
  setSwitchToCombo,
  updateBetsWithLatestApiData
} = BetSlipSlice.actions;

export default BetSlipSlice.reducer;
